import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import { InputContainer } from '../admin/addAdminModal/AddAdminModal';
import miscService from 'src/service/miscServices';

export default function OccupationMultiSelect({
  setOccupation,
  occupationError,
}: {
  setOccupation: Function;
  occupationError: string;
}) {
  const theme = useTheme();

  const [occupationName, setOccupationName] = useState<string | null>(null);
  const [occupations, setOccupations] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    miscService
      .getAllOccupations()
      .then((res) => {
        const occupationObj = res?.data?.payload?.data || [];
        const formatted = occupationObj.map((item: any) => item.name);
        setOccupations(formatted);
      })
      .catch((err) => console.log(err?.response))
      .finally(() => setLoading(false));
  }, []);

  return (
    <InputContainer>
      <label htmlFor="Occupation">Occupation</label>

      <FormControl fullWidth size="small">
        <Autocomplete
          options={occupations}
          value={occupationName}
          loading={loading}
          onChange={(event, newValue) => {
            setOccupationName(newValue);

            setOccupation((prevState: any) => ({
              ...prevState,
              occupation: newValue ? [newValue] : [],
              occupationError: '',
            }));
          }}
          renderInput={(params) => (
            <TextField
              {...params}
            //   label="Search Occupation"
            //   size="small"
              error={!!occupationError}
              helperText={occupationError}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? <CircularProgress size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </FormControl>
    </InputContainer>
  );
}